import { Card, SkeletonCard, SkeletonText, Stack } from '@optimus-web/core';
import { SecurityDataTestId } from '../utils/SecurityDataTestId';

export const SecurityCardSkeleton = () => (
    <Card padding="200" outline data-test-id={SecurityDataTestId.SecurityCardSkeleton}>
        <Stack vertical spacing="100">
            <Stack distribution="space-between" spacing="100" itemAlignment="center">
                <Stack spacing="100" itemAlignment="center">
                    <SkeletonText width="200px" fontSize={18} />
                    <SkeletonCard height="20px" width="60px" />
                </Stack>
                <SkeletonCard height="20px" width="60px" />
            </Stack>
            <SkeletonText width="90%" fontSize={16} />
            <SkeletonText width="40%" fontSize={16} />
        </Stack>
    </Card>
);
